'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isUndefined = function isUndefined(value) {
  return typeof value === 'undefined';
};

exports.default = function (raw) {
  return raw && Object.keys(raw).filter(function (key) {
    return !isUndefined(raw[key]);
  }).reduce(function (obj, key) {
    return _extends({}, obj, _defineProperty({}, key, raw[key]));
  }, {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cheesecakelabs/fetch/utils/compact-object.js
// module id = 306
// module chunks = 0